'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('cobIntrastateValidation', cobIntrastateValidation);

	cobIntrastateValidation.$inject = [
		'subjectObserverMessagesService', 'observerService', 'carrierRegistrationService', '$state', 'authenticationService'
	];

	var subjectObserverMessagesService,
		observerService,
		carrierRegistrationService,
		subjectMessages,
		observerMessages,
		$state,
		authenticationService;

	function cobIntrastateValidation(_subjectObserverMessagesService_,
		_observerService_,
		_carrierRegistrationService_,
		_$state_,
		_authenticationService) {
		carrierRegistrationService = _carrierRegistrationService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		$state = _$state_;
		authenticationService = _authenticationService;

		return {
			scope: {
				visible: '='
			},
			templateUrl: '/app/common/welcome/intrastateValidation.html',
			replace: true,
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope
				.m = {
					errors: [],
					intrastateCodeError: '',
					showErrorModal: false,
					intrastateStateError: '',
					intrastateNumber: '',
					selectedState: '',
					stateList: [
						{ key: 'AL', value: 'Alabama' },
						{ key: 'AK', value: 'Alaska' },
						{ key: 'AS', value: 'American Samoa' },
						{ key: 'AZ', value: 'Arizona' },
						{ key: 'AR', value: 'Arkansas' },
						{ key: 'CA', value: 'California' },
						{ key: 'CO', value: 'Colorado' },
						{ key: 'CT', value: 'Connecticut' },
						{ key: 'DE', value: 'Delaware' },
						{ key: 'DC', value: 'District of Columbia' },
						{ key: 'FL', value: 'Florida' },
						{ key: 'GA', value: 'Georgia' },
						{ key: 'GU', value: 'Guam' },
						{ key: 'HI', value: 'Hawaii' },
						{ key: 'ID', value: 'Idaho' },
						{ key: 'IL', value: 'Illinois' },
						{ key: 'IN', value: 'Indiana' },
						{ key: 'IA', value: 'Iowa' },
						{ key: 'KS', value: 'Kansas' },
						{ key: 'KY', value: 'Kentucky' },
						{ key: 'LA', value: 'Louisiana' },
						{ key: 'ME', value: 'Maine' },
						{ key: 'MD', value: 'Maryland' },
						{ key: 'MA', value: 'Massachusetts' },
						{ key: 'MI', value: 'Michigan' },
						{ key: 'MN', value: 'Minnesota' },
						{ key: 'MS', value: 'Mississippi' },
						{ key: 'MO', value: 'Missouri' },
						{ key: 'MT', value: 'Montana' },
						{ key: 'NE', value: 'Nebraska' },
						{ key: 'NV', value: 'Nevada' },
						{ key: 'NH', value: 'New Hampshire' },
						{ key: 'NJ', value: 'New Jersey' },
						{ key: 'NM', value: 'New Mexico' },
						{ key: 'NY', value: 'New York' },
						{ key: 'NC', value: 'North Carolina' },
						{ key: 'ND', value: 'North Dakota' },
						{ key: 'OH', value: 'Ohio' },
						{ key: 'OK', value: 'Oklahoma' },
						{ key: 'OR', value: 'Oregon' },
						{ key: 'PA', value: 'Pennsylvania' },
						{ key: 'PR', value: 'Puerto Rico' },
						{ key: 'RI', value: 'Rhode Island' },
						{ key: 'SC', value: 'South Carolina' },
						{ key: 'SD', value: 'South Dakota' },
						{ key: 'TN', value: 'Tennessee' },
						{ key: 'TX', value: 'Texas' },
						{ key: 'UT', value: 'Utah' },
						{ key: 'VT', value: 'Vermont' },
						{ key: 'VA', value: 'Virginia' },
						{ key: 'VI', value: 'Virgin Islands' },
						{ key: 'WA', value: 'Washington' },
						{ key: 'WV', value: 'West Virginia' },
						{ key: 'WI', value: 'Wisconsin' },
						{ key: 'WY', value: 'Wyoming' },
					]
				};

			scope.validateIntrastateCode = validateIntrastateCode;
			scope.navigateToSection = navigateToSection;
		}

		function validateIntrastateCode() {
			if (validateInput()) {
				setTimeout(function() {
					observerService
						.sendMessageToSubject(scope,
							subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_WAITING);
				},
				1);

				carrierRegistrationService.validateIntrastateCode(scope.m.selectedState.key, scope.m.intrastateNumber)
					.then(function(response) {
						if (response.data.validationInfo === 'Authorized' &&
                            response.data.carrierList !== null) {
							navigateToSection(
								{
									setActiveSlide: 'confirmCompanySection',
									carrierList: response.data.carrierList,
									numberText: 'Number entered:',
									searchNumber: scope.m.selectedState.key + '/' + scope.m.intrastateNumber,
									modalMessage: '',
									modalTitle: ''
								});
						}

						if (response.data.validationInfo === 'IntrastateCodeNotFound') {
							scope.m.showNotFound = true;
						} else {
							scope.m.showNotFound = false;
						}

						if (response.data.validationInfo === 'Authorized' && response.data.carrierId !== -1) {
							navigateToSection(
								{
									modalMessage:
									'<br/><p><strong>The information provided matches an existing ' +
									'account. <a href="' + authenticationService.getLogoutUrl() + '">Please follow this link to log in</a>. ' +
									'You will be redirected to a new screen.</strong></p>',
									modalTitle: 'Account Found'
								});
						}

					})
					.catch(function(e) {
						console.log(e);
					})
					.finally(function() {
						observerService
							.sendMessageToSubject(scope,
								subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_AJAX_DONE);
					});
			}
		}

		function validateInput() {
			scope.m.intrastateCodeError = '';
			scope.m.intrastateStateError = '';

			if (scope.m.selectedState === '') {
				scope.m.intrastateStateError = 'Valid input is required.';
			} else {
				scope.m.intrastateStateError = '';
			}

			if (scope.m.intrastateNumber.length === 0) {
				scope.m.intrastateCodeError = 'Valid input is required.';
			} else {
				scope.m.intrastateCodeError = '';
			}

			return (scope.m.intrastateStateError === '' && scope.m.intrastateCodeError === '');
		}

		function navigateToSection(sectionObject) {

			scope.m.errors = [];
			scope.m.showNotFound = '';
			scope.m.intrastateCodeError = '';
			scope.m.showErrorModal = false;
			scope.m.intrastateStateError = '';

			scope.m.intrastateNumber = '';
			scope.m.selectedState = '';

			observerService.sendMessageToSubject(scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_CHANGE_WELCOME_VIEW,
				sectionObject);
		}
	}

})();
